import { Fragment } from 'react/jsx-runtime';
import logoFreespaceBlu from '../../../assets/freespace-logo-blu.png';
import logoFreespace from '../../../assets/freespace-logo.png';

const MainLogo = ({ variant }: { variant: 'blu' | 'white' }) => {
    return (
        <Fragment>
            {variant === 'blu' && (
                <img
                    height={'100%'}
                    src={logoFreespaceBlu}
                    alt="logo Freespace"
                />
            )}
            {variant === 'white' && (
                <img height={'100%'} src={logoFreespace} alt="logo Freespace" />
            )}
        </Fragment>
    );
};

export default MainLogo;
